export default [
  // 新建/编辑物品
  {
    name: 'cu-material',
    component: () => import(/* webpackChunkName: "cu-material" */ './cu-material.vue'),
  },
];
